module.exports = __webpack_public_path__ + "static/media/paymentInfo_blue.1660c36b.svg";